import React from "react";
import data from "./data.json";

export default function Search({
  buyNumber,
  formBuyingValidation,
  formEditingValidation,
  setSearchInput,
  searchInput,
}) {
  return (
    <div className="dropdown">
      <input
        className="form-control dropdown-toggle"
        type="text"
        autoComplete="off"
        id="dropdownMenu"
        data-toggle="dropdown"
        ref={buyNumber}
        value={searchInput}
        aria-haspopup="true"
        // aria-expanded="false"
        placeholder="اسم الشركة او رقمها"
        onChange={(e) => {
          setSearchInput(e.target.value);
          formBuyingValidation();
          //عشان لما اضيف من اضافة اسهم لا يتم التعرف على الفورم فالديشين من التحرير
          if (!formEditingValidation) return;
          formEditingValidation();
        }}
      ></input>
      <small className="text-danger d-none" id="nonumber">
        يرجى اضافة اسم الشركة
      </small>
      <div
        className="dropdown-menu dropdown-menu-right w-100 overflow-auto text-right p-0"
        aria-labelledby="dropdownMenu"
      >
        {data
          .filter((val) => {
            return (
              val.name.includes(searchInput) || val.id.includes(searchInput)
            );
          })
          .map((val) => {
            return (
              <div
                key={val.name}
                className="p-1 border-bottom border-white"
                id="companiesID"
                onClick={() => {
                  setSearchInput(`${val.id} - ${val.name}`);
                  document
                    .querySelectorAll("#nonumber")[0]
                    .classList.add("d-none");
                  document
                    .querySelectorAll("#dropdownMenu")[0]
                    .classList.remove("border", "border-danger");
                  document
                    .querySelectorAll("#nonumber")[1]
                    .classList.add("d-none");
                  document
                    .querySelectorAll("#dropdownMenu")[1]
                    .classList.remove("border", "border-danger");
                }}
              >
                {val.id} - {val.name}
              </div>
            );
          })}
      </div>
    </div>
  );
}
